module.exports = __webpack_public_path__ + "img/type--2-spans--multiple-lang--en.fad46294.jpg";